
export class PaymentMethod {
    id: number;
    name: string;
    gateway: string;
    imagePath: string;
    status: number;
}
